export interface Link {
  content: string;
  href: string;
  trackInAdobe?: boolean;
}
